// FETCH ALL CASH_REQUISITION
export const FETCH_CASH_REQUISITION_REQUEST = 'FETCH_CASH_REQUISITION_REQUEST';
export const FETCH_CASH_REQUISITION_SUCCESS = 'FETCH_CASH_REQUISITION_SUCCESS';
export const FETCH_CASH_REQUISITION_FAILURE = 'FETCH_CASH_REQUISITION_FAILURE';

export const FETCH_CASH_REQUISITION_CRFNO_REQUEST = 'FETCH_CASH_REQUISITION_CRFNO_REQUEST';
export const FETCH_CASH_REQUISITION_CRFNO_SUCCESS = 'FETCH_CASH_REQUISITION_CRFNO_SUCCESS';
export const FETCH_CASH_REQUISITION_CRFNO_FAILURE = 'FETCH_CASH_REQUISITION_CRFNO_FAILURE';

export const FETCH_CASH_REQUISITION_STYLES_REQUEST = 'FETCH_CASH_REQUISITION_STYLES_REQUEST';
export const FETCH_CASH_REQUISITION_STYLES_SUCCESS = 'FETCH_CASH_REQUISITION_STYLES_SUCCESS';
export const FETCH_CASH_REQUISITION_STYLES_FAILURE = 'FETCH_CASH_REQUISITION_STYLES_FAILURE';

export const CREATE_CASH_REQUISITION_FORM_DETAILS = 'CREATE_CASH_REQUISITION_FORM_DETAILS';
export const CREATE_CASH_REQUISITION_FORM_DETAILS_REQUEST = 'CREATE_CASH_REQUISITION_FORM_DETAILS_REQUEST';
export const CREATE_CASH_REQUISITION_FORM_DETAILS_SUCCESS = 'CREATE_CASH_REQUISITION_FORM_DETAILS_SUCCESS';
export const CREATE_CASH_REQUISITION_FORM_DETAILS_FAILURE = 'CREATE_CASH_REQUISITION_FORM_DETAILS_FAILURE';

export const FETCH_SINGLE_CASH_REQUISITION_FORM_REQUEST = 'FETCH_SINGLE_CASH_REQUISITION_FORM_REQUEST';
export const FETCH_SINGLE_CASH_REQUISITION_FORM_SUCCESS = 'FETCH_SINGLE_CASH_REQUISITION_FORM_SUCCESS';
export const FETCH_SINGLE_CASH_REQUISITION_FORM_FAILURE = 'FETCH_SINGLE_CASH_REQUISITION_FORM_FAILURE';

export const UPDATE_CASH_REQUISITION_FORM_DETAILS_REQUEST = 'UPDATE_CASH_REQUISITION_FORM_DETAILS_REQUEST';
export const UPDATE_CASH_REQUISITION_FORM_DETAILS_SUCCESS = 'UPDATE_CASH_REQUISITION_FORM_DETAILS_SUCCESS';
export const UPDATE_CASH_REQUISITION_FORM_DETAILS_FAILURE = 'UPDATE_CASH_REQUISITION_FORM_DETAILS_FAILURE';

export const DELETE_CASH_REQUISITION_FORM_DETAILS_REQUEST = 'DELETE_CASH_REQUISITION_FORM_DETAILS_REQUEST';
export const DELETE_CASH_REQUISITION_FORM_DETAILS_SUCCESS = 'DELETE_CASH_REQUISITION_FORM_DETAILS_SUCCESS';
export const DELETE_CASH_REQUISITION_FORM_DETAILS_FAILURE = 'DELETE_CASH_REQUISITION_FORM_DETAILS_FAILURE';

export const CASH_REQUISITION_CASHFORM_RESET = 'CASH_REQUISITION_CASHFORM_RESET';

export const NAVIGATE_CASH_REQUISITION_DETAILS = 'NAVIGATE_CASH_REQUISITION_DETAILS';
export const NAVIGATE_CASH_REQUISITION = 'NAVIGATE_CASH_REQUISITION';
export const CASH_REQUISITION_CASHFORM_NAVIGATE_TO_DETAIL_TAB = 'CASH_REQUISITION_CASHFORM_NAVIGATE_TO_DETAIL_TAB';
export const CASH_REQUISITION_CASHFORM_NAVIGATE_TO_DETAIL_REVERSE = 'CASH_REQUISITION_CASHFORM_NAVIGATE_TO_DETAIL_REVERSE';
export const CASH_REQUISITION_CASHFORM_EDIT = 'CASH_REQUISITION_CASHFORM_EDIT';

export const CASH_REQUISITION_FORMS_OF_REQUISITOR_NAME_REQUEST = 'CASH_REQUISITION_FORMS_OF_REQUISITOR_NAME_REQUEST'
export const CASH_REQUISITION_FORMS_OF_REQUISITOR_NAME_SUCCESS = 'CASH_REQUISITION_FORMS_OF_REQUISITOR_NAME_SUCCESS'
export const CASH_REQUISITION_FORMS_OF_REQUISITOR_NAME_FAILURE = 'CASH_REQUISITION_FORMS_OF_REQUISITOR_NAME_FAILURE'


export const FETCH_CASH_SUPPLIER_LIST2_REQUEST = 'FETCH_CASH_SUPPLIER_LIST2_REQUEST';
export const FETCH_CASH_SUPPLIER_LIST2_SUCCESS = 'FETCH_CASH_SUPPLIER_LIST2_SUCCESS';
export const FETCH_CASH_SUPPLIER_LIST2_FAILURE = 'FETCH_CASH_SUPPLIER_LIST2_FAILURE';

export const HEADER_SEARCH_CALL_ONLOAD = 'HEADER_SEARCH_CALL_ONLOAD';

export const FETCH_MULTIPLE_CASH_REQUISITION_INVOICE_REQUEST = 'FETCH_MULTIPLE_CASH_REQUISITION_INVOICE_REQUEST';
export const FETCH_MULTIPLE_CASH_REQUISITION_INVOICE_SUCCESS = 'FETCH_MULTIPLE_CASH_REQUISITION_INVOICE_SUCCESS';
export const FETCH_MULTIPLE_CASH_REQUISITION_INVOICE_FAILURE = 'FETCH_MULTIPLE_CASH_REQUISITION_INVOICE_FAILURE';

export const RESET_CASH_REQUISITION_INVOICE_DATA = 'RESET_CASH_REQUISITION_INVOICE_DATA';

export const FETCH_CASH_REQUISITION_REPORT_REQUEST = 'FETCH_CASH_REQUISITION_REPORT_REQUEST';
export const FETCH_CASH_REQUISITION_REPORT_SUCCESS = 'FETCH_CASH_REQUISITION_REPORT_SUCCESS';
export const FETCH_CASH_REQUISITION_REPORT_FAILURE = 'FETCH_CASH_REQUISITION_REPORT_FAILURE';

export const SET_TAB_NAME_CASH_REQUISITION_DATA = 'SET_TAB_NAME_CASH_REQUISITION_DATA';